export default function formatDate (datePar: string):string {
  const time = datePar.split(' ')[0];
  const date = new Date(time.replace(/-/g,'/'));
  const chinaDate = date.toDateString();
  const globalDate = date.toUTCString();
  const chinaDateArray = chinaDate.split(' '); 
  const displayDate = chinaDateArray[1] + ' '+ chinaDateArray[2]+','+ chinaDateArray[3]; 
  return displayDate;
}